<!--
 * @Author: your name
 * @Date: 2022-03-16 08:43:30
 * @LastEditTime: 2022-04-02 14:32:19
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Do-network\src\views\pc\intro\Blog.vue
-->
<template>
  <div>
    <div class="Blog">
      <div class="Blog-all">
        <div class="Blog-title">
          <p>{{ $t("Blog.NetworkBlog") }}</p>
        </div>
        <router-link  :to="{ path: '/pc/BlogDetails', query: { id: obj.blogId }, }">
          <div class="DoNetwork-Blog clearfix">
            <div class="Blog-lfet">
              <img :src="obj.images" alt="" />
            </div>

            <div class="Blog-right clearfix">
              <div class="clearfix">
                <div class="Blog-right-imgs">
                  <img :src=obj.avatar alt="" />
                </div>
                <div class="Blog-right-title">
                  <p class="Blog-right-title-p">{{ obj.createBy }}
                  </p>
                  <p class="Blog-right-p">{{ obj.createTime }}</p>
                </div>
              </div>
              <div class="Blog-right-center">
                <p>{{ obj.blogTitle }}</p>
              </div>
              <div class="Blog-right-buttom">
                <p v-html="obj.text">
                </p>
              </div>
            </div>
          </div>
        </router-link>

        <div class="Blog-paging-all clearfix">
          <div  class="Blog-paging-top"  v-for="blog in blogList"  :key="blog.blogId" >
            <router-link :to="{ path: '/pc/BlogDetails', query: { id: blog.blogId }, }" >
              <div class="Blog-paging-imgs">
                <img :src="blog.images" alt="" />
              </div>
              <p class="Blog-paging-text-top">
                {{ blog.blogTitle }}
              </p>
              <p class="Blog-paging-text-center" v-html="blog.text">
              </p>
              <p class="Blog-paging-text-buttom">{{ blog.createTime }}</p>
            </router-link>
          </div>
        </div>

        <!-- 分页器 -->
        <div class="block">
          <el-pagination
                  layout="prev,pager,next"
                  :total="total"
                  @current-change="handleCurrentChange"
                  :current-page="pageSize"
          ></el-pagination>
        </div>
        <div>
          <div class="Blog-footer">
            <div class="Blog-footer-title">
              <p>{{ $t("Blog.join") }}</p>
            </div>
            <div class="Blog-footer-title-p">
              <p>
                {{ $t("Blog.detail1") }}
              </p>
            </div>
            <div class="clearfix">
              <el-form
                      ref="emailForm"
                      :model="emailForm"
                      :rules="rules"
                      label-width="120px">
                <el-form-item prop="mailAddress">
                  <el-input   placeholder="Enter your email address"  v-model="emailForm.email"
                  ></el-input>
                  <el-button @click="subBlog">{{ $t("Blog.subscribe")}}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GetBlogList, SubBlog } from "@/assets/server/api";
  import { baseURL, trimHtml } from "@/utils/utils";
  export default {
    data() {
      return {
        blogList: [],
        dialogVisible: false,
        email: "",
        pageSize: 1,
        total: 0,
        obj: {},
        emailForm: {
          email: null,
        },
        rules: {
          email: [
            { required: true, message: "Enter your email address", trigger: "change" },
          ],
        },
        // email:"",
      };
    },
    created() {
      let userName = localStorage.getItem("username");
      document.cookie = "autoLogin=" + userName;
     // this.getBlogList();
    },
    methods: {
      handleCurrentChange(currentPage) {
        this.pageSize = currentPage;
        //this.getBlogList();
      },
      handleClose() {
        this.dialogVisible = false;
        this.emailForm.email = "";
      },
      async subBlog() {
        let id = this.obj.blogId;
        let reg = /\w+@[a-z0-9]+\.[a-z]{2,4}/;
        if (!reg.test(this.emailForm.email)) {
          return this.$message.warning("enter the correct email address");
        }
        let info = id + "/" + this.emailForm.email;
        const data = await SubBlog(info);
        // console.log(data);
        if (data.code === 0) {
          this.emailForm.email = "";
          // this.folg1 = true;
          // this.getBlogList();
          this.$message.success( "success");
          this.handleClose();
        } else {
          this.$message.error(data.msg);
        }
      },
      async getBlogList() {
        const data = await GetBlogList({
          pageNo: this.pageSize,
          pageSize: 9,
        });
        // console.log("博客列表详情",data);
        if (data.code === 0) {
          data.rows.forEach((item) => {
            item.text = trimHtml(item.text);
          });
          this.obj = data.rows[0];
          this.blogList = data.rows;
          this.total = data.total;
        } else {
          this.$message.error(data.msg);
        }
      },
    },
  };

</script>

<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .clearfix:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .clearfix {
    *zoom: 1;
  }
  .Blog {
    color: #000;
    background: url(../../../assets/pc/intro/back.png) no-repeat center / 108% 65%;
    background-position: 0 185px;
    .Blog-all {
      width: 1190px;
      height: 100%;
      margin: 0 auto;
      padding: 231px 0 0 0;
      .Blog-title {
        // margin-top: 159px;
        font-size: 75px;
        font-weight: 900;
        font-family: Popping-Blak, Popping;
        color: #000;
        line-height: 97px;
        -webkit-background-clip: text;
      }
      .DoNetwork-Blog {
        margin: 60px 0 160px 0;
        .Blog-lfet {
          width: 600px;
          height: 410px;
          background: #4573e7;
          float: left;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .Blog-right {
          float: left;
          margin: 14px 0 0 100px;
          .Blog-right-imgs {
            //   background: linear-gradient(142deg, #8021ea 0%, #2a66f1 100%);
            opacity: 1;
            float: left;
            margin-right: 24px;
            img {
              width: 42px;
              height: 42px;
            }
          }
          .Blog-right-title {
            float: left;
            .Blog-right-title-p {
              font-size: 20px;
              font-weight: 800;
              color: #000;
              line-height: 31px;
              -webkit-background-clip: text;
              font-family: Popping-ExtraBold, Poppins;
            }
            .Blog-right-p {
              font-size: 12px;
              color: #a8aeb7;
              font-family: Microsoft YaHei UI-Regular, Microsft Yahei UI;
              font-weight: 400;
              line-height: 14px;
              -webkit-background-clip: text;
            }
          }
          .Blog-right-center {
            width: 100%;
            height: 35px;
            font-size: 22px;
            font-weight: bold;
            color: #2f2f2f;
            line-height: 35px;
            -webkit-background-clip: text;
            font-family: Microsoft YaHei-Bold, Microsft Yahei;
            text-align: left;
            margin-top: 17px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            p {
              width: 394px;
              height: 35px;
            }
          }
          .Blog-right-buttom {
            width: 490px;
            height: 120px;
            font-size: 14px;
            color: #737582;
            font-weight: 500;
            line-height: 24px;
            -webkit-background-clip: text;
            font-family: Poppins-Medium, Poppins;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            word-wrap: break-word;
            -webkit-box-orient: vertical;
            p {
              font-size: 14px;
              font-family: Poppins-Medium, Poppins;
              font-weight: 500;
              color: #737582;
              line-height: 24px;
              -webkit-background-clip: text;
            }
            img {
              display: none !important;
            }
          }
        }
      }
      .Blog-paging-top {
        float: left;
        width: 380px;
        margin-bottom: 110px;
        .Blog-paging-imgs {
          width: 380px;
          height: 260px;
          background-color: #4573e7;
          img {
            width: 380px;
            height: 260px;
          }
        }

        .Blog-paging-text-top {
          width: 100%;
          /*height: 70px;*/
          font-size: 22px;
          font-weight: bold;
          color: #2f2f2f;
          line-height: 35px;
          margin: 30px 0 10px 0;
          -webkit-background-clip: text;
          font-family: Microsoft YaiHei-Bold, Microsoft YaHei;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          word-wrap: break-word;
          -webkit-box-orient: vertical;
        }
        .Blog-paging-text-center {
          width: 100%;
          height: 77px;
          margin-bottom: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          // line-height: 0 !important;
          font-size: 14px !important;
          font-family: Poppins-Medium, Poppins !important;
          font-weight: 500 !important;
          color: #737582 !important;
          line-height: 24px !important;
          -webkit-background-clip: text !important;
          .MsoNormal {
            line-height: 0 !important;
            span {
              font-size: 14px !important;
              font-family: Poppins-Medium, Poppins !important;
              font-weight: 500 !important;
              color: #737582 !important;
              line-height: 24px !important;
              -webkit-background-clip: text !important;
            }
          }
        }
        .Blog-paging-text-buttom {
          width: 130px;
          height: 25px;
          background: rgba(20, 120, 255, 0.05);
          font-size: 12px;
          color: #4573e7;
          font-weight: 400;
          font-family: Ubuntu-Regular, Ubuntu;
          line-height: 25px;
          -webkit-background-clip: text;
        }
      }
      .Blog-paging-top:nth-child(2) {
        margin: 0 25px;
      }
      .Blog-paging-top:nth-child(5) {
        margin: 0 25px;
      }
      .Blog-paging-top:nth-child(8) {
        margin: 0 25px;
      }
      .center {
        margin: 0 25px 0 25px;
      }
      .Blog-paging-all-buttom {
        margin: 95px 0 125px 0;
      }
      // 设置分页器样式
      .block {
        text-align: center;
        margin: 15px 0 146px 0;
      }
    }
  }

  .block /deep/ .el-pager li {
    min-width: 33px;
    min-height: 33px;
    text-align: center;
    line-height: 33px;
  }
  .block /deep/ .el-pager li.active {
    background-color: #4573e7 !important;
    color: #fff !important;
    width: 33px;
    height: 33px;
    border-radius: 50%;
    line-height: 33px;
    padding: 0;
  }
  .Blog-footer {
    box-sizing: border-box;
    width: 100%;
    height: 260px;
    background: rgba(69, 115, 231, 0.03);
    border-top: 2px solid #4573e7;
    padding: 48px 50px 59px 50px;
    margin-bottom: 289px;
    .Blog-footer-title {
      font-size: 20px;
      font-weight: bold;
      color: #000;
      line-height: 23px;
      margin-left: 10px;
      -webkit-background-clip: text;
      font-family: Microsoft YaiHei-Bold, Microsoft YaHei;
    }
    .Blog-footer-title-p {
      font-size: 14px;
      color: #4573e7;
      font-weight: 400;
      line-height: 20px;
      margin: 15px 0 40px 10px;
      -webkit-background-clip: text;
      font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
    }
    .el-form /deep/ .el-form-item{
      .el-form-item__content{
        margin-left: 0 !important;
      }

    }
    .el-input{
      width: 840px;
      height: 50px;
      float: left;
    }
    .el-input /deep/ input{
      width: 840px;
      height: 50px;
      border: 2px solid #767676;
      float: left;
      font-size: 14px;
      padding: 14px 30px 15px 30px;
      border-radius: 30px;
      color: #999;
      -webkit-background-clip: text;
      font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
      outline: none;
      box-sizing: border-box;
    }
    button {
      float: left;
      border-radius: 31px;
      height: 50px;
      border: 2px solid #4573e7;
      padding: 14px 56px 15px 56px;
      color: #4573e7;
      font-size: 16px;
      font-weight: 400;
      -webkit-background-clip: text;
      font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
      margin-left: 61px;
      box-sizing: border-box;
    }
  }
</style>
